export default __webpack_public_path__ + "static/media/2-pieces-upper-mantle.538122e4.svg";